import type { GameModel, ReadOnlyGameModel } from 'yage/game/GameModel';
import { AirportBag, AirportPassenger } from '../components/index.js';
import { nextStage } from '../domain/config.js';
import { travellerRoute } from './act2.js';
import { ids, stations } from './world.js';

/** Bag Drop stops when this many bags are in the terminal (the rack is full). */
export const RACK_LIMIT = 24;
/** A served traveller waits at the desk while the next line already holds this many people. */
export const NEXT_LINE_ROOM = 12;
/** Travellers at a desk, queued or in service. */
export function lineLength(g: GameModel | ReadOnlyGameModel, index: number) {
    return ids(g, AirportPassenger).filter(id => { const p = g.getTypedUnsafe(AirportPassenger, id); return p.stage === index && p.state !== 3; }).length;
}
/** Why a desk is holding a traveller it has finished with: a full bag rack, or no room in the next line. */
export function deskHold(g: GameModel | ReadOnlyGameModel, index: number): { reason: 'rack' } | { reason: 'line'; next: number } | null {
    const ss = stations(g);
    if (index === 1 && ss[1]?.unlocked && ids(g, AirportBag).length >= RACK_LIMIT) return { reason: 'rack' };
    for (const id of ids(g, AirportPassenger)) {
        const p = g.getTypedUnsafe(AirportPassenger, id);
        if (p.stage !== index || p.state !== 2 || p.remaining > 0) continue;
        const next = nextStage(index, ss, travellerRoute(g, p.serial, p.vip));
        if (ss[next]?.unlocked && lineLength(g, next) >= NEXT_LINE_ROOM) return { reason: 'line', next };
    }
    return null;
}
